import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { TabPanel } from '@grapecity/wijmo.nav';
import { KYMW0400InputModel } from './vo/kymw0400-input.model';
import { KYMW0400OutputModel } from './vo/kymw0400-output.model';
import { KYMW0400Model } from './kymw0400.model';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { GetSupplierListService } from './api-services/get-supplier-list.service';

/**
 * 取引先一覧画面を管理するクラス
 *
 * @export KYMW0400Component
 * @class KYMW0400Component
 */
@Component({
  selector: 'app-kymw0400',
  templateUrl: 'kymw0400.component.html',
  styleUrls: ['kymw0400.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0400Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dg_Supplier', { static: true }) dg_Supplier: FlexGrid;
  @ViewChild('Supplier', { static: true }) Supplier: TabPanel;

  private tabMap: Map<number, string>
    = new Map([
      [0, 'ｱ'],
      [1, 'ｶ'],
      [2, 'ｻ'],
      [3, 'ﾀ'],
      [4, 'ﾅ'],
      [5, 'ﾊ'],
      [6, 'ﾏ'],
      [7, 'ﾔ'],
      [8, 'ﾗ'],
      [9, 'ﾜ'],
      [10, ''],
    ]);

  private dataMap = new Map<string, any[]>();
  public isDataMapReady = false;

  // 親画面からの連携値
  param: any;

  kymw0400Model: KYMW0400Model = new KYMW0400Model();

  setKYMW0400Parameter: Function;

  /**
   *Creates an instance of KYMW0400Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetSupplierListService} getSupplierListService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0400Component
   */
  constructor(
    private getSupplierListService: GetSupplierListService,
    private kymw00Model: KYMW00Model,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0400Component
   */
  public async ngOnInit(): Promise<void> {
    this.componentName = 'KYMW0400';
    // ア行の取引先一覧を取得する
    await this.getAllSupplierList();
    this.isDataMapReady = true;
    this.dg_Supplier.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dg_Supplier.select(-1, -1);
    });

    // クリックでチェックボックスにチェックを入れる
    this.addEventListener_dg_SupplierSelected();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0400Component
   */
  public async setInterfaceParam(param: any): Promise<void> {
    const vo = <KYMW0400InputModel>param;
    // 呼出元区分(0：発注先取引先、1：支払先取引先)を保持
    this.kymw0400Model.supplierFlg = vo.supplierFlg;
    // 複数選択モード(true: チェックボックス表示)
    this.kymw0400Model.isMultiCheckable = vo.isMultiCheckable;
    // 複数選択モードかつ取引先が設定済みの場合チェックを入れる
    if (vo.isMultiCheckable && vo.multiSuppliers?.length) {
      // dataMap完成まで待機
      await this.waitDataMapReady();
      this.dataMap.forEach(supplierArray => {
        supplierArray.forEach(item => {
          item.check = vo.multiSuppliers.some(s => s.supplierCode === item.SupplierCode);
        });
      });
    }
  }

  /**
   * タブキーによるフォーカス移動処理
   *
   * @memberof KYMW0400Component
   */
  public eventNextTabHandler(event: any): void {
    if (event.keyCode === 9 && !event.shiftKey) {
      // 後続のデフォルトイベントをキャンセル
      event.preventDefault();
      let nextNum = this.Supplier.selectedIndex + 1;
      // 最後のタブから移動する場合
      if (this.Supplier.selectedIndex === this.Supplier.tabs.length - 1) {
        nextNum = 0;
      }
      this.Supplier.selectedIndex = nextNum;
      this.getSupplierList(this.tabMap.get(nextNum), nextNum);
    }
  }

  /**
   * 選択ボタン クリックイベント処理
   *
   * @memberof KYMW0400Component
   */
  public eventSelect_CLICKHandler(e: MouseEvent): void {

    // 複数選択の場合
    if (this.kymw0400Model.isMultiCheckable) {

      // 呼び出し元画面に選択行データを返却
      const outputVO: KYMW0400OutputModel = new KYMW0400OutputModel();
      outputVO.supplierFlg = this.kymw0400Model.supplierFlg;

      for(const dataList of this.dataMap.values()){
        const checkedList = dataList.filter(item => item.check).map(_ => {
          return {
            tradeStopDiv: _.TradeStopDiv,
            supplierCode: _.SupplierCode,
            supplierNameKanji: _.SupplierNameKanji
          }
        });
        outputVO.multiSuppliers = [...outputVO.multiSuppliers, ...checkedList];
      }
      // 呼び出し元画面に値を返す
      this.setKYMW0400Parameter(outputVO);

      // 閉じる
      super.onClickClose();

      return;
    }

    // 選択行の有無チェック
    if (PlessViewUtilsSub.isEmptyArray(this.dg_Supplier.selectedItems)) {       // 選択行なしの場合
      // 処理復帰
      return;
    }

    // ヘッダー内部がクリックされている場合は何もしない
    if (this.dg_Supplier.hitTest(e).cellType === CellType.ColumnHeader              // カラムヘッダーである、
      || this.dg_Supplier.hitTest(e).edgeLeft                                                // 左端、
      || this.dg_Supplier.hitTest(e).edgeRight) {                                            // 右端の場合
      // 判定結果を返却
      return;
    }

    // 呼び出し元画面に選択行データを返却
    const outputVO: KYMW0400OutputModel = new KYMW0400OutputModel();
    outputVO.supplierCode = this.dg_Supplier.selectedItems[0].SupplierCode;
    outputVO.supplierNameKanji = this.dg_Supplier.selectedItems[0].SupplierNameKanji;
    outputVO.tradeStopDiv = this.dg_Supplier.selectedItems[0].TradeStopDiv;
    outputVO.supplierFlg = this.kymw0400Model.supplierFlg;

    // 呼び出し元画面に値を返す
    this.setKYMW0400Parameter(outputVO);

    // 閉じる
    super.onClickClose();
  }

  /**
   * 全取引先一覧取得
   *
   * @memberof KYMW0400Component
   */
  public async getAllSupplierList(): Promise<void> {
    // 全検索ｶﾅ行タブの分、各行リクエストパラメータを設定して、取引先一覧取得APIを呼び出す。
    for (const [key, value] of this.tabMap){
      const searchKana = value;
      this.kymw0400Model.searchKana = searchKana;
      
      const data = await new Promise<any[]>((resolve) => {
        // API呼び出し
        this.getSupplierListService.execute(this.kymw0400Model, (response: any) => {
          resolve(response);
        });
      })
      this.dataMap.set(searchKana, data);
    }

    // 初期表示設定
    const initKey = this.tabMap.get(0);
    this.kymw0400Model.supplierList = this.dataMap.get(initKey);
  }

  /**
   * 50音タブ クリックイベント処理
   *
   * @memberof KYMW0400Component
   */
  public getSupplierList(kana: string, idx: number): void {
    const displayData = this.dataMap.get(kana) || [];
    this.kymw0400Model.searchKana = kana;
    this.kymw0400Model.index = idx;
    this.kymw0400Model.supplierList = displayData;
  }

  /**
  * 複数選択用
  * クリックでチェックボックスにチェックを入れる
  * @memberof KYMW0400Component
  */
  public addEventListener_dg_SupplierSelected(): void {
    if (!this.kymw0400Model.isMultiCheckable) {
      return;
    }
    this.dg_Supplier.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dg_Supplier.hitTest(e);
      if (0 <= ht.row && (!ht.target.className.includes('wj-header') && !ht.target.className.includes('ng-valid'))) {
        if (ht.col === 0) {
          document.getElementById(`selected_${ht.row}`)?.click();
        }
      }
    });
  }

  /**
  * 複数選択用
  * dataMap完成するまで待機を行う
  * @memberof KYMW0400Component
  */
  private waitDataMapReady(): Promise<void> {
    return new Promise(resolve => {
      const check = () => this.isDataMapReady ? resolve() : setTimeout(check, 50);
      check();
    });
  }

  /**
  * wijimo上でダブルクリック時処理
  * @memberof KYMW0400Component
  */
  public onRowDoubleClick(e: MouseEvent): void  {
    // 複数選択モード時は何もしない
    if (this.kymw0400Model.isMultiCheckable) {
      return;
    }

    this.eventSelect_CLICKHandler(e);
  }
}
